/* FormDialogRenderer.js */

"use strict";
const _ = require("lodash");
const Forms = require("@gluenetworks/forms").ui.component;
const ButtonControl = require("@gluenetworks/button_control");

class FormDialogRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("form-dialog-gl");
        this._rootElem.classList.add("modal_feedback_container");
        this._rootElem.component = this._model;

        this._formsComponent = new Forms();

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._formsComponent.on(
            "PendingPatchesChanged",
            (this._onPendingPatchesChanged = this._onPendingPatchesChanged.bind(this))
        );
        this._formsComponent.on(
            "DirtyStateChanged",
            (this._onDirtyStateChanged = this._onDirtyStateChanged.bind(this))
        );
    }
    _unregisterListeners() {
        this._formsComponent.removeListener("PendingPatchesChanged", this._onPendingPatchesChanged);
        this._formsComponent.removeListener("DirtyStateChanged", this._onDirtyStateChanged);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [Promise.resolve()];

        return Promise.all(promArr)
            .then(() => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                return this._formsComponent.shutdown();
            })
            .then(() => {
                this._formsComponent = undefined;
            });
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (!this._rootElem.hasChildNodes()) {
            this._titleElem = document.createElement("h2");
            this._msgElem = document.createElement("p");
            this._formsElem = this._formsComponent.renderer.rootElement;
            this._actionsContainer = document.createElement("div");
            this._actionsContainer.classList.add("actions_container");

            this._rootElem.appendChild(this._titleElem);
            this._rootElem.appendChild(this._msgElem);
            this._rootElem.appendChild(this._formsElem);
            this._rootElem.appendChild(this._actionsContainer);
        }

        this._renderTitle();
        this._renderMsg();
        this._renderActions();
        return this._renderForm();
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    _renderTitle() {
        this._titleElem.innerText = this._model.title;
    }
    _renderMsg() {
        let msg = this._model.getMessage();
        if (msg) {
            this._msgElem.classList.remove("hidden");
            this._msgElem.innerText = msg;
        } else {
            this._msgElem.classList.add("hidden");
            this._msgElem.innerText = "";
        }
    }
    _renderForm() {
        let typeInfo = this._model.getTypeInformation();
        let pristineValue = this._model.getPristineValue();

        this._formsComponent.setTypeInformation(typeInfo, true);
        this._formsComponent._setPristineValue(pristineValue, true);

        return this._formsComponent.renderer.render();
    }
    _renderActions() {
        let confElem = this._renderAction(this._model.confirmationDeets);
        confElem.classList.add("confirmation_action");
        confElem.addEventListener("click", () => {
            this._model.confirm(this._formsComponent.getValue());
        });
        let rejectElem = this._renderAction(this._model.rejectionDeets);
        rejectElem.classList.add("rejection_action");
        rejectElem.addEventListener("click", () => {
            this._model.reject();
        });
        this._actionsContainer.appendChild(rejectElem);
        this._actionsContainer.appendChild(confElem);
    }
    _renderAction(deets) {
        let actionElem;
        let btn;
        switch (deets.type) {
            case "text":
                btn = new ButtonControl({
                    label: deets.text,
                    darkTheme: true,
                });
                actionElem = btn.renderer.rootElement;
                break;
            case "destructive":
                btn = new ButtonControl({
                    label: deets.text,
                    darkTheme: true,
                });
                actionElem = btn.renderer.rootElement;
                actionElem.classList.add("destructive");
                break;
            case "additive":
                btn = new ButtonControl({
                    label: deets.text,
                    darkTheme: true,
                });
                actionElem = btn.renderer.rootElement;
                actionElem.classList.add("additive");
                break;
        }

        if (deets.classes) {
            let classStr = deets.classes;
            if (_.isString(deets.classes)) {
                classStr = deets.classes.split(" ");
            }
            actionElem.classList.add.apply(actionElem.classList, classStr);
            actionElem.classList.add("action");
        }

        return actionElem;
    }
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onPendingPatchesChanged() {
        // console.log("Patches Changed",this._formsComponent.getPendingPatches());
        // console.log("New Value is ",this._formsComponent.getValue());
    }
    _onDirtyStateChanged() {
        // console.log("Dirty State Changed",this._formsComponent.isDirty());
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = FormDialogRenderer;
